import { Controller } from '@hotwired/stimulus'

// Per-agent relocation settings: reveal the cross-number template picker only
// when that mode is selected. Each agent card is its own controller scope, so
// toggling one number never touches another.
export default class extends Controller {
  static targets = ['mode', 'template']

  connect() {
    this.toggle()
  }

  toggle() {
    const crossNumber = this.modeTarget.value === 'cross_number'
    this.templateTargets.forEach((el) => el.classList.toggle('hidden', !crossNumber))
  }
}
